import { FunctionComponent } from 'react'

import DesktopTabletHighFive from '@components/Multiline/HighFive/DesktopTabletHighFive'
import MobileHighFive from '@components/Multiline/HighFive/MobileHighFive'

import { HighFiveProps } from './types'

const HighFiveLayout: FunctionComponent<HighFiveProps> = ({ ...props }) => {
  return (
    <>
      <DesktopTabletHighFive {...props} />
      <MobileHighFive {...props} />
    </>
  )
}

export default HighFiveLayout
